import React, { useEffect } from "react";

import { Route, Routes } from "react-router-dom";
import { GetRoutes, IKlasisRoute } from "./configuration/routes";

import { THEMES_LIST } from "./constants/themes";
import { SCALES_LIST } from "./constants/fontScales";

import { useAppSelector } from "./hooks/redux";

import { ThemeProvider } from "@mui/material/styles";
import Layout from "./parts/Layout";
import { CssBaseline } from "@mui/material";
import { LocaleProvider } from "./providers/LocaleProvider";
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "./utils/snackbar";
import ServerError from "./components/snackbar/ServerError";

function RenderRoutes(routes?: IKlasisRoute[]): JSX.Element[] | undefined {
    if (!routes?.length) return undefined;

    const result = routes.map((route, index) => {
        return (
            <Route
                key={index}
                path={route.path}
                index={route.index}
                element={route.element}
            >
                {RenderRoutes(route.children)}
            </Route>
        );
    });

    return result;
}

const App: React.FC = () => {
    const settings = useAppSelector((state) => state.settings);

    useEffect(() => {
        document.getElementsByTagName("html")[0].style.fontSize = `${
            SCALES_LIST[settings.fontScale].size
        }%`;
    }, [settings.fontScale]);

    return (
        <ThemeProvider theme={THEMES_LIST[settings.theme].theme}>
            <CssBaseline>
                <LocaleProvider>
                    <SnackbarProvider
                        maxSnack={3}
                        Components={{
                            serverError: ServerError,
                        }}
                    >
                        <SnackbarUtilsConfigurator />
                        <Routes>
                            <Route path="/" element={<Layout />}>
                                {RenderRoutes(GetRoutes())}
                            </Route>
                        </Routes>
                    </SnackbarProvider>
                </LocaleProvider>
            </CssBaseline>
        </ThemeProvider>
    );
};

export default App;
